import { render, staticRenderFns } from "./img.vue?vue&type=template&id=b45d0d3c&scoped=true"
import script from "./img.vue?vue&type=script&lang=js"
export * from "./img.vue?vue&type=script&lang=js"
import style0 from "./img.vue?vue&type=style&index=0&id=b45d0d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45d0d3c",
  null
  
)

export default component.exports